import {
    InformeCedulaCatastralProvincia,
    InformePlanoMensuraSubdivisionCapital,
    FormInformeEscrituraProvincia,
    FormConsultaAlIndiceTitularidad,
    FormCesionProvincia,
    FormDominioMatriculadoProvincia,
    FormEmpresarialProvincia,
    FormFrecuenciaProvincia,
    FormInhibicionProvincia,
    FormDominioAutomotor,
    FormInhibicionAutomotor,
    FormInformePartidaUnionConvivencial,
    FormPartidaDefuncion,
    FormPartidaMatrimonio,
    FormPartidaNacimiento,
    FormCertificadoCatastral,
    FormInscripcionOficios,
    FormPlanchetaDistribucionParcelaria,
    FormValuacionFiscalP,
    FormCedulaCatastralAbogados,
    FormPatentamientos,
    FormTransferencias,
    FormInformeBienesPersonales,
    FormInformeDominio,
    FormEmpresarial,
    FormInformeFrecuenciaCapital,
    FormInhibicionCapital,
    FormInformeTitularidadCapital,
    FormInformeEscritura,
    FormDominioNoMatriculadoProvincia,
    FormObraCapital,
    FormPlanchetaCapital,
    FormValuacionFiscalC,
    FormPlanoMensuraSubdivisionProvincia,
    FormTitularidadDomino,
    FormPlanoObraSanitariaCapital,
    FormEstadoParcelarioCapital,
    FormEstudioPrefectCapital,
    FormEstadoParcelarioProvincia,
    FormEstudioPrefectibilidadProvincia,
    FormInteriorPais
} from "@/components/Informes";


import { TipoInforme } from "@/redux/models";


export type seccionType = 'capital' | 'provincia' | 'catastro' | 'otros';



export const FormInformesMap = new Map<string, any>([
    //capital
    ['FormInformeDominio', FormInformeDominio],
    ['FormInhibicionCapital', FormInhibicionCapital],
    ['FormInformeTitularidadCapital', FormInformeTitularidadCapital],
    ['FormInformeBienesPersonales', FormInformeBienesPersonales],
    ['FormInformeFrecuenciaCapital', FormInformeFrecuenciaCapital],
    ['FormEmpresarial', FormEmpresarial],
    ['FormInformeEscritura', FormInformeEscritura],
    ['FormTitularidadDomino', FormTitularidadDomino],
    //provincia
    ['FormInhibicionProvincia', FormInhibicionProvincia],
    ['FormConsultaAlIndiceTitularidad', FormConsultaAlIndiceTitularidad],
    ['FormInformeEscrituraProvincia', FormInformeEscrituraProvincia],
    ['FormCesionProvincia', FormCesionProvincia],
    ['FormEmpresarialProvincia', FormEmpresarialProvincia],
    ['FormFrecuenciaProvincia', FormFrecuenciaProvincia],
    ['FormDominioMatriculadoProvincia', FormDominioMatriculadoProvincia],
    ['FormDominioNoMatriculadoProvincia', FormDominioNoMatriculadoProvincia],

    //catastro
    ['InformePlanoMensuraSubdivisionCapital', InformePlanoMensuraSubdivisionCapital],
    ['FormPlanoMensuraSubdivisionProvincia', FormPlanoMensuraSubdivisionProvincia],
    ['InformeCedulaCatastralProvincia', InformeCedulaCatastralProvincia],
    ['FormObraCapital', FormObraCapital],
    ['FormPlanchetaCapital', FormPlanchetaCapital],
    ['FormPlanoObraSanitariaCapital', FormPlanoObraSanitariaCapital],
    ['FormEstadoParcelarioCapital', FormEstadoParcelarioCapital],
    ['FormEstadoParcelarioProvincia', FormEstadoParcelarioProvincia],
    ['FormEstudioPrefectCapital', FormEstudioPrefectCapital],
    ['FormEstudioPrefectibilidadProvincia', FormEstudioPrefectibilidadProvincia],
    ['FormValuacionFiscalP', FormValuacionFiscalP],
    ['FormValuacionFiscalC', FormValuacionFiscalC],

    //otros
    ['FormDominioAutomotor', FormDominioAutomotor],
    ['FormInhibicionAutomotor', FormInhibicionAutomotor],
    ['FormPartidaDefuncion', FormPartidaDefuncion],
    ['FormPartidaMatrimonio', FormPartidaMatrimonio],
    ['FormPartidaNacimiento', FormPartidaNacimiento],
    ['FormInformePartidaUnionConvivencial', FormInformePartidaUnionConvivencial],
    ['FormPatentamientos', FormPatentamientos],
    ['FormTransferencias', FormTransferencias],
    ['FormCedulaCatastralAbogados', FormCedulaCatastralAbogados],
    ['FormCertificadoCatastral', FormCertificadoCatastral],
    ['FormInscripcionOficios', FormInscripcionOficios],
    ['FormPlanchetaDistribucionParcelaria', FormPlanchetaDistribucionParcelaria],
    ['FormInteriorPais', FormInteriorPais]

]);

export type listaDeInformeEntryType = {
    nombre: string,
    path: string,
    ComponentName: string,
    seccion: seccionType,
    tipos: { [key in TipoInforme]?: { nombre: string } },
    subdivision?: string

}

export const listaDeInformeEntry = (
    nombre: string,
    path: string,
    ComponentName: string,
    seccion: seccionType,
    tipos: { [key in TipoInforme]?: { nombre: string } },
    subdivision?: string
) => {
    const value = FormInformesMap.get(ComponentName);
    if (value) {
        return {
            nombre,
            path,
            ComponentName,
            seccion,
            tipos,
            subdivision
        }
    } else {
        throw new Error(`Componente "${ComponentName}" no encontrado en el Map.`);
    }
};




export const listaDeInformes = [
    //capital
    listaDeInformeEntry('Dominio', 'informe-dominio', 'FormInformeDominio', 'capital',
        {
            [TipoInforme.DominioCapitalAntiguo]: { nombre: 'Informe de Dominio Capital Antiguo' },
            [TipoInforme.DominioCapitalModerno]: { nombre: 'Informe de Dominio Capital Moderno' },
        }
    ),
    listaDeInformeEntry('Inhibición', 'informe-inhibicion-capital', 'FormInhibicionCapital', 'capital',
        {
            [TipoInforme.InhibicionCapitalFisica]: { nombre: 'Informe de Inhibición Capital Física' },
            [TipoInforme.InhibicionCapitalJuridica]: { nombre: 'Informe de Inhibición Capital Jurídica' },
        }
    ),
    listaDeInformeEntry('Bienes Personales', 'informe-bienes-personales-capital', 'FormInformeBienesPersonales', 'capital',
        {
            [TipoInforme.BienesPersonalesCapitalFisica]: { nombre: 'Informe de Bienes Personales Física' },
            [TipoInforme.BienesPersonalesCapitalJuridica]: { nombre: 'Informe de Bienes Personales Jurídica' },
        }
    ),
    listaDeInformeEntry('Frecuencia', 'informe-frecuencia', 'FormInformeFrecuenciaCapital', 'capital',
        {
            [TipoInforme.FrecuenciaCapital]: { nombre: 'Informe de Frecuencia Capital' },
        }
    ),
    listaDeInformeEntry('Titularidad', 'informe-titularidad', 'FormInformeTitularidadCapital', 'capital',
        {
            [TipoInforme.TitularidadCapital]: { nombre: 'Informe de Titularidad Capital' },
        }
    ),
    listaDeInformeEntry('Empresarial', 'informe-empresarial', 'FormEmpresarial', 'capital',
        {
            [TipoInforme.EmpresarialCapitalFisica]: { nombre: 'Informe Empresarial Física' },
            [TipoInforme.EmpresarialCapitalJuridica]: { nombre: 'Informe Empresarial Jurídica' },
        }
    ),
    listaDeInformeEntry('4B Administradores', 'informe-titularidad-dominio-capital', 'FormTitularidadDomino', 'capital',
        {
            [TipoInforme.TitularidadDominioCapital]: { nombre: 'Informe Titularidad Dominio (Capital)' },
        }
    ),
    listaDeInformeEntry('Copia de Escritura o Reglamento', 'informe-copia-escritura-capital', 'FormInformeEscritura', 'capital',
        {
            [TipoInforme.CopiaDeEscrituraYReglamentos]: { nombre: 'Informe Copia Escritura' },
        }
    ),
    //provincia
    listaDeInformeEntry('Dominio Matriculado', 'informe-dominio-matriculado-provincia', 'FormDominioMatriculadoProvincia', 'provincia', {
        [TipoInforme.DominioProvinciaMatriculado]: { nombre: 'Informe de Dominio Matriculado (Provincia)' },
    }),
    listaDeInformeEntry('Dominio No Matriculado', 'informe-dominio-no-matriculado', 'FormDominioNoMatriculadoProvincia', 'provincia', {
        [TipoInforme.DominioProvinciaNoMatriculado]: { nombre: 'Informe de Dominio No Matriculado (Provincia)' },
    }),
    listaDeInformeEntry('Inhibición', 'informe-inhibicion-provincia', 'FormInhibicionProvincia', 'provincia', {
        [TipoInforme.InhibicionProvinciaFisica]: { nombre: 'Informe de Inhibición Capital Física (PBA)' },
        [TipoInforme.InhibicionProvinciaJuridica]: { nombre: 'Informe de Inhibición Capital Jurídica (PBA)' },

    }),
    listaDeInformeEntry('Cesión', 'informe-cesion-provincia', 'FormCesionProvincia', 'provincia', {
        [TipoInforme.CesionProvinciaFisica]: { nombre: 'Informe de Cesión Física' },
        [TipoInforme.CesionProvinciaJuridica]: { nombre: 'Informe de Cesión Jurídica' },
    }),
    listaDeInformeEntry('Frecuencia', 'informe-frecuencia-provincia', 'FormFrecuenciaProvincia', 'provincia', {
        [TipoInforme.FrecuenciaProvincia]: { nombre: 'Informe de Frecuencia' },
    }),
    listaDeInformeEntry('Consulta al Índice de Titulares', 'informe-consulta-indice-titularidad-provincia', 'FormConsultaAlIndiceTitularidad', 'provincia', {
        [TipoInforme.ConsultaIndiceTitularesProvinciaFisica]: { nombre: 'Informe de consulta al índice de titularidad Física' },
        [TipoInforme.ConsultaIndiceTitularesProvinciaJuridica]: { nombre: 'Informe de consulta al índice de titularidad Jurídica' },
    }),
    listaDeInformeEntry('Empresarial Provincia', 'informe-empresarial-provincia', 'FormEmpresarialProvincia', 'provincia', {
        [TipoInforme.EmpresarialProvinciaFisica]: { nombre: 'Informe Empresarial Física (PBA)' },
        [TipoInforme.EmpresarialProvinciaJuridica]: { nombre: 'Informe Empresarial Jurídica (PBA)' },
    }),
    listaDeInformeEntry('Copia de Escritura o Reglamento', 'informe-copia-escritura-provincia', 'FormInformeEscrituraProvincia', 'provincia', {
        [TipoInforme.CopiaDeEscrituraYReglamentosProvincia]: { nombre: 'Copia de Escritura Provincia' },
    }),

    //catastro
    listaDeInformeEntry('Plano de Mensura y Subdivisión en Propiedad Horizontal', 'informe-plano-mensura-subdivision-capital', 'InformePlanoMensuraSubdivisionCapital', 'catastro', {
        [TipoInforme.PlanoMensuraSubdivicionCapital]: { nombre: 'Informe de Plano Mensura Capital' },
    }, 'capital'),

    listaDeInformeEntry('Plano de Obra (fincas)', 'informe-obra-capital', 'FormObraCapital', 'catastro', {
        [TipoInforme.PlanoObraCapital]: { nombre: 'Informe de Obra Capital' },
    }, 'capital'),

    listaDeInformeEntry('Plano de Obras Sanitarias (AySA)', 'informe-plano-obra-sanitaria-catastro', 'FormPlanoObraSanitariaCapital', 'catastro', {
        [TipoInforme.PlanoObraSanitariaCapitalCatastro]: { nombre: 'Informe Plano Obra Sanitaria (Catastro)' },
    }, 'capital'),
    listaDeInformeEntry('Planchetas', 'informe-plancheta-capital', 'FormPlanchetaCapital', 'catastro', {
        [TipoInforme.PlanchetaCapital]: { nombre: 'Informe plancheta (Capital)' },
    }, 'capital'),
    listaDeInformeEntry('Valuación Fiscal', 'informe-valuacion-fiscal-capital', 'FormValuacionFiscalC', 'catastro', {
        [TipoInforme.ValuacionFiscalCapital]: { nombre: 'Informe de Valuación Fiscal (capital)' },
    }, 'capital'),
    listaDeInformeEntry('Estudio de Prefactibilidad de Terrenos', 'informe-estudio-Prefectibilidad-capital-catastro', 'FormEstudioPrefectCapital', 'catastro', {
        [TipoInforme.EstudioPrefectibilidadCapitalCatastro]: { nombre: 'Informe Estudio Prefectibilidad (Catastro capital)' },
    }, 'capital'),
    listaDeInformeEntry('Estado Parcelario', 'informe-estado-parcelario-capital-catastro', 'FormEstadoParcelarioCapital', 'catastro', {
        [TipoInforme.EstadoParcelarioCapitalCatastro]: { nombre: 'Informe Estado Parcelario (Catastro capital)' },
    }, 'capital'),
    listaDeInformeEntry('Valuación Fiscal', 'informe-valuacion-fiscal-provincia', 'FormValuacionFiscalP', 'catastro', {
        [TipoInforme.ValuacionFiscalP]: { nombre: 'Informe de Valuación Fiscal (Provincia)' },
    }, 'provincia'),
    listaDeInformeEntry('Plano de Mensura y Subdivisión en Propiedad Horizontal', 'informe-plano-mensura-subdivision-Provincia', 'FormPlanoMensuraSubdivisionProvincia', 'catastro', {
        [TipoInforme.PlanoMensuraSubdivicionProvincia]: { nombre: 'Informe de Plano Mensura Provincia' },
    }, 'provincia'),
    listaDeInformeEntry('Cédula Catastral', 'informe-plano-cedula-catastral-provincia', 'InformeCedulaCatastralProvincia', 'catastro', {
        [TipoInforme.CedulaCatastralProvincia]: { nombre: 'Informe Cédula Catastral Provincia' },
    }, 'provincia'),
    // Certificado catastral
    listaDeInformeEntry('Certificado Catastral', 'informe-certificado-catastral', 'FormCertificadoCatastral', 'catastro', {
        [TipoInforme.CertificadoCatastralP]: { nombre: 'Informe de Certificado Catastral (Provincia)' },
    }, 'provincia'),
    listaDeInformeEntry('Plancheta de Distribución Parcelaria', 'informe-plancheta-distribucion-parcelaria', 'FormPlanchetaDistribucionParcelaria', 'catastro', {
        [TipoInforme.PlanchetaDistribucionParcelariaP]: { nombre: 'Informe de Plancheta Distribucion Parcelaria' },
    }, 'provincia'),
    listaDeInformeEntry('Estudio de Prefactibilidad de Terrenos', 'informe-estudio-Prefectibilidad-provincia-catastro', 'FormEstudioPrefectibilidadProvincia', 'catastro', {
        [TipoInforme.EstudioPrefectibilidadProvinciaCatastro]: { nombre: 'Informe Estudio Prefectibilidad (Catastro provincia)' },
    }, 'provincia'),
    listaDeInformeEntry('Estados parcelarios', 'informe-estado-parcelario-provincia-catastro', 'FormEstadoParcelarioProvincia', 'catastro', {
        [TipoInforme.EstadoParcelarioProvinciaCatastro]: { nombre: 'Informe Estado Parcelario (Catastro provincia)' },
    }, 'provincia'),


    //otros
    listaDeInformeEntry('Dominio Automotor', 'informe-dominio-automotor', 'FormDominioAutomotor', 'otros', {
        [TipoInforme.DominioAutomotor]: { nombre: 'Informe de Dominio Automotor' }
    }, 'automotor'),
    listaDeInformeEntry('Inhibición Automotor', 'informe-inhibicion-automotor', 'FormInhibicionAutomotor', 'otros', {
        [TipoInforme.InhibicionAutomotorFisica]: { nombre: 'Informe de Inhibición Automotor Física' },
        [TipoInforme.InhibicionAutomotorJuridica]: { nombre: 'Informe de Inhibición Automotor Jurídica' },
    }, 'automotor'),
    listaDeInformeEntry('Patentamientos', 'informe-patentamientos', 'FormPatentamientos', 'otros', {
        [TipoInforme.Patentamiento]: { nombre: 'Informe de Patentamientos' },
    }, 'automotor'),
    listaDeInformeEntry('Transferencias', 'informe-transferencias', 'FormTransferencias', 'otros', {
        [TipoInforme.Transferencia]: { nombre: 'Informe de Transferencias' },
    }, 'automotor'),
    listaDeInformeEntry('Partida de Defunción', 'informe-partida-defuncion', 'FormPartidaDefuncion', 'otros', {
        [TipoInforme.PartidaDefuncion]: { nombre: 'Informe de Partida Defunción' },
    }, 'partidas'),
    listaDeInformeEntry('Partida de Matrimonio', 'informe-partida-matrimonio', 'FormPartidaMatrimonio', 'otros', {
        [TipoInforme.PartidaMatrimonio]: { nombre: 'Informe de Partida Matrimonio' },
    }, 'partidas'),
    listaDeInformeEntry('Partida de Nacimiento', 'informe-partida-nacimiento', 'FormPartidaNacimiento', 'otros', {
        [TipoInforme.PartidaNacimiento]: { nombre: 'Informe de Partida Nacimiento' },
    }, 'partidas'),
    listaDeInformeEntry('Partida de Unión Convivencial', 'informe-partida-union-convivencial', 'FormInformePartidaUnionConvivencial', 'otros', {
        [TipoInforme.PartidaUnionConvivencial]: { nombre: 'Informe de Partida Unión Convivencial' },
    }, 'partidas'),
    listaDeInformeEntry('Inscripción Oficios', 'informe-inscripcion-oficios', 'FormInscripcionOficios', 'otros', {
        [TipoInforme.InscripcionOficiosPoC]: { nombre: 'Informe de Inscripción Oficios' },
    }, 'abogados'),
    listaDeInformeEntry('Solicitar Informes', 'informes-interior-pais', 'FormInteriorPais', 'otros', {
        [TipoInforme.InformeGeneralInterior]: { nombre: 'Informe General Interior' },
    }, 'Informes del interior del país'),



]



function generateListaDeTiposDeInforme() {
    const listaDeTiposDeInforme: any = {};
    listaDeInformes.forEach((informe: any) => {
        Object.keys(informe.tipos).forEach((tipo: any) => {
            if (!listaDeTiposDeInforme[tipo]) {
                listaDeTiposDeInforme[tipo] = [];
            }
            listaDeTiposDeInforme[tipo].push({
                nombre: informe.tipos[tipo].nombre,
                informe: informe.nombre,
                path: informe.path,
                seccion: informe.seccion,
                component: informe.ComponentName,
            });
        });
    });
    return listaDeTiposDeInforme;
}

export { generateListaDeTiposDeInforme };





